export default __webpack_public_path__ + "static/media/sf_logo.322dfbc1.png";